<template>
  <b-form
    @submit.prevent="realizaLogin"
    class="user-form">
    <InputBasico
      type="text"
      label='Usuário*'
      name='usuario'
      :lowerCase='true'
      placeholder='Ex. joanasilva'
      v-model="form.usuario"
      v-validate="'required'"
      :errorsBag="errors"
    />

    <InputBasico
      type='password'
      label='Senha*'
      name='senha'
      placeholder='Informe sua senha'
      v-model="form.password"
      v-validate="'required'"
      :errorsBag="errors"
    />

    <b-button
      class="button-full-width"
      type="submit"
      variant="primary">
      Entrar
    </b-button>
  </b-form>
</template>

<script>
import bForm from 'bootstrap-vue/es/components/form/form'
import bButton from 'bootstrap-vue/es/components/button/button'
import InputBasico from '@/components/inputs/InputBasico.vue'

export default {
  name: 'LoginForm',
  components: {
    bForm,
    bButton,
    InputBasico,
  },
  data() {
    return {
      form: {
        usuario: '',
        password: '',
      },
    }
  },
  methods: {
    realizaLogin() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('login', JSON.parse(JSON.stringify(this.form)))
        }
      })
    },
    mostrarCamposRecuperarConta() {
      this.$emit('recuperarConta')
    },
  },
}

</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';
@import '@/scss/colors.scss';

.user-form {
  display: flex;
  flex-direction: column;

  padding: 2rem 1rem 1rem;
  border-radius: 0.3rem;
  box-shadow: 2px 4px 8px $cor-fundo-escura;
  background-color: $cor-fundo-clara;

  @media (min-width: $medium-size) {
    margin: 1em;
    width: 275px;
  }

  @media (min-width: $large-size) {
    width: 375px;
  }
}

.button-full-width {
  margin: 0.5rem 0;
  height: 3rem;
}

.btnRecuperarSenha {
  margin-top: 1rem;
}

</style>
